import getBlogItem from '@/api/blog/getBlogItem.endpoint';
import BlogItem from '@/pages/Blog/BlogItem';
import PageMetadata from '@/v2/domains/SEO/components/PageMetadata/PageMetadata';
import { cleanAndTruncateText } from '@/modules/stringUtils';

export default function BlogPage({ pageProps: { blogItem } }) {
  const seoDescription =
    (blogItem.seoMetadata?.description ?? blogItem.description)
      ? cleanAndTruncateText(blogItem.description)
      : '';

  return (
    <>
      <PageMetadata
        title={blogItem.title}
        description={seoDescription}
        ogImage={blogItem.image}
      />
      <BlogItem blogItem={blogItem} />
    </>
  );
}

export const getServerSideProps = async (context) => {
  const blogItemSlug = context.params.slug;
  const blogItem = await getBlogItem(blogItemSlug);

  if (!blogItem) {
    return {
      notFound: true,
    };
  } else {
    return {
      props: {
        blogItem,
      },
    };
  }
};
